//import { observable, computed, action, decorate, extendObservable } from "mobx"
import { action, extendObservable } from "mobx"

export const User = function (firstName, lastName) {
    // initialize observable properties on a new instance
    extendObservable(
        this,
        {
            firstName: firstName,
            lastName: "alici",
            get fullName() {
                return this.firstName + "  " + this.lastName
            },
            setFirstName(firstName) {
                this.firstName = firstName
            }
        },
        {
            setFirstName: action
        }
    )
}

const userStore = new User()
export const stores = {
    userStore: userStore
}

// default {
//	User: User
//}
//export default function initializeStores() {
//	return {
//		userStore: new User(),
//	}
//}


// WEBPACK FOOTER //
// ./src/store/index.js